export default __webpack_public_path__ + "static/media/empty_retailers.bbfa6bca.png";